import React, { useContext } from 'react';
import { EnvironmentContext } from '../context';
import { ServerCard } from './ServerCard';
import SummaryCard from './SummaryCard';

export const EnvMain = () => {
  const ctx = useContext(EnvironmentContext);
  const { env } = ctx.state;

  return (
    <div className="md:px-0 px-4 flex flex-col">
      <SummaryCard />
      <div className="flex flex-row gap-6">{env && <ServerCard stack={env.stack} />}</div>
    </div>
  );
};
